/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
export function removeCookie(key) {
  setCookie(key, "", -1);
}

export function setCookie(key, value, expiryDays) {
  const d = new Date();
  d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie =
    key + "=" + value + ";" + expires + ";path=/;secure;SameSite=Lax";
}

export function getCookie(key) {
  const match = document.cookie.match(new RegExp("(^| |;)" + key + "=([^;]+)"));
  return match ? match[2] : "";
}
